<template>
  <div class="relative rounded-lg flex items-center overflow-hidden p-0.5 bg-gradient-to-r from-[#32B0A1] to-[#20AAFA]"
    :class="isHomePage ? 'h-16' : 'h-12'">
    <div class="flex items-center gap-4 px-2 sm:px-4 h-full w-full bg-gray-300 rounded-lg">
      <div class="flex flex-col whitespace-nowrap text-start justify-center">
        <span class="flex flex-col sm:flex-row text-[#1A56DB] font-bold items-center justify-center"
          :class="isHomePage ? 'text-xl sm:text-2xl' : 'text-base sm:text-lg'">
          <span class="text-sm md:text-base">Round</span>
          <span class="sm:ml-1 text-sm md:text-base -mt-1 sm:mt-0">{{ currentRound }}</span>
        </span>
        <span class="hidden sm:block font-bold text-[#0B1426] leading-none text-xs -mt-1"
          :class="isHomePage ? 'text-xs sm:text-sm' : 'text-xs'">
          ends in
        </span>
      </div>

      <div class="flex items-center justify-center"
        :class="isHomePage ? 'gap-1 sm:gap-2 md:gap-3 h-10 sm:h-12' : 'gap-1 h-8 sm:h-10'">
        <TimeUnit :value="timeToShow.days" label="DAYS" :large="isHomePage" />
        <TimeUnit :value="timeToShow.hours" label="HRS" :large="isHomePage" />
        <TimeUnit :value="timeToShow.minutes" label="MIN" :large="isHomePage" />
        <TimeUnit :class="[
          isHomePage ? ' hidden xs:flex' : 'hidden sm:flex flex-col'
        ]" :value="timeToShow.seconds" label="SEC" :large="isHomePage" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import TimeUnit from './TimeUnit.vue';

const props = {
  now: usePage().props.round.current_time,
  end: usePage().props.round.round_end,
  current_round: usePage().props.round.current_round,
  round_interval: usePage().props.round.round_interval,
};

const isHomePage = computed(() => {
  return window.location.pathname === '/';
});

const currentTime = ref(new Date(props.now).getTime());
const endTime = ref(new Date(props.end).getTime());
const roundInterval = ref(Number(props.round_interval));
const currentRound = ref(props.current_round);

const timeToShow = computed(() => {
  const diff = (new Date(endTime.value) - new Date(currentTime.value)) / 1000;
  return {
    days: formatToShow(Math.floor(diff / 86400)),
    hours: formatToShow(Math.floor(diff / 3600) % 24),
    minutes: formatToShow(Math.floor(diff / 60) % 60),
    seconds: formatToShow(Math.floor(diff) % 60),
  }
})

function formatToShow(value) {
  return value < 10 ? `0${value}` : value;
}

function substractSecond() {
  endTime.value = endTime.value - 1000;
  if (endTime.value < currentTime.value) {
    currentTime.value = new Date().getTime();
    endTime.value = new Date(props.end).getTime() + roundInterval.value;
    currentRound.value = currentRound.value + 1;
  }
}

onMounted(() => {
  setInterval(() => {
    substractSecond()
  }, 1000);
});

defineProps({
  title: {
    type: [String, Number],
    required: true
  },
  subtitle: {
    type: String,
    required: true
  },
  days: {
    type: Number,
    required: true
  },
  hours: {
    type: Number,
    required: true
  },
  minutes: {
    type: Number,
    required: true
  },
  seconds: {
    type: Number,
    required: true
  }
});
</script>